import { FlowBuilderContext } from '@/contexts/FlowBuilderContext';
import { useContext } from 'react';

export function useFlowBuilder() {
  const context = useContext(FlowBuilderContext);
  if (!context) {
    throw new Error('useFlowBuilder must be used within FlowBuilderProvider');
  }
  return context;
}
